// extracted by mini-css-extract-plugin
module.exports = {"backButton":"BackButton_backButton__JqdDg","styleIcon":"BackButton_styleIcon__Jzq_4"};